import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  Radio,
  Select,
  Typography,
} from "antd";
import FormActions from "../../../organisms/FormActions";

const DeliverySchedule = ({ form, formData, setFormData, handlePublish }) => {
  return (
    <Flex
      vertical
      gap={22}
      className="bg-color-white rounded shadow px-7 pt-6 pb-7 mb-[80px]"
    >
      <Flex justify="space-between" vertical={false}>
        <Flex vertical>
          <Typography.Title level={5}>Step 3</Typography.Title>
          <Typography.Title level={4} style={{ marginTop: "0" }}>
            Delivery Schedule
          </Typography.Title>
        </Flex>
        <Flex gap={20}>
          <Button
            size="large"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Flex>
      </Flex>

      <Flex
        vertical
        style={{
          border: "1px solid #E4E6EF",
          borderRadius: "12px",
        }}
      >
        <Typography.Text
          style={{
            marginTop: "0",
            fontSize: "14px",
            fontWeight: "500",
            padding: "24px",
          }}
        >
          Schedule Information
        </Typography.Text>
        <Divider style={{ margin: "0" }} />
        <Form form={form} layout="vertical" style={{ padding: "24px" }}>
          <Form.Item
            label="Delivery Schedule"
            name="deliveryScheduleType"
            rules={[
              {
                required: true,
              },
            ]}
            initialValue={0}
          >
            <Radio.Group
              className="flex-wrap"
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  deliveryScheduleType: e.target.value,
                }))
              }
              value={formData.deliveryScheduleType}
            >
              <Radio value={0}>Send Now</Radio>
              <Radio value={1}>Send Later</Radio>
            </Radio.Group>
          </Form.Item>

          {form.getFieldValue("deliveryScheduleType") == 1 && (
            <Col span={12}>
              <Form.Item
                label="Date & Time"
                name="scheduledDateTime"
                rules={[
                  {
                    required: true,
                    message: "Date & time is required",
                  },
                ]}
              >
                <DatePicker
                  size="large"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  value={formData.scheduledDateTime}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      scheduledDateTime: e.format("YYYY-MM-DD HH:mm:ss"),
                    }));
                  }}
                />
              </Form.Item>
            </Col>
          )}
        </Form>
      </Flex>

      <Flex
        vertical
        style={{
          border: "1px solid #E4E6EF",
          borderRadius: "12px",
        }}
      >
        <Typography.Text
          style={{
            marginTop: "0",
            fontSize: "14px",
            fontWeight: "500",
            padding: "24px",
          }}
        >
          Delivery Recurrence
        </Typography.Text>
        <Divider style={{ margin: "0" }} />
        <Col span={12}>
          <Form form={form} layout="vertical" style={{ padding: "24px" }}>
            <Form.Item
              label="Select recurrence"
              name="deliveryRecurrenceType"
              rules={[
                {
                  required: true,
                },
              ]}
              initialValue={1}
            >
              <Select
                placeholder="Select"
                size="large"
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    deliveryRecurrenceType: value,
                  }));
                }}
                value={formData.deliveryRecurrenceType}
              >
                <Option value={1}>Does not repeat</Option>
                <Option value={2}>Custom</Option>
              </Select>
            </Form.Item>

            {form.getFieldValue("deliveryRecurrenceType") == 2 && (
              <>
                <Flex gap={16} align="center" style={{ marginBottom: "32px" }}>
                  <Typography.Text>Repeat every</Typography.Text>
                  <Form.Item
                    name="recurrenceInterval"
                    initialValue={1}
                    style={{ margin: 0 }}
                  >
                    <Input
                      size="large"
                      value={formData.recurrenceInterval}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          recurrenceInterval: e.target.value,
                        }));
                      }}
                      type="number"
                      style={{ maxWidth: "100px" }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="recurrenceType"
                    initialValue={0}
                    style={{ margin: 0, flex: 1 }}
                  >
                    <Select
                      placeholder="Select"
                      size="large"
                      onChange={(value) => {
                        setFormData((prev) => ({
                          ...prev,
                          recurrenceType: value,
                        }));
                      }}
                      value={formData.recurrenceType}
                    >
                      <Option value={0}>Days</Option>
                      <Option value={1}>Week</Option>
                      <Option value={2}>Month</Option>
                      {/* <Option value={4}>Week</Option> */}
                    </Select>
                  </Form.Item>
                </Flex>

                <Form.Item
                  name="endRecurrenceType"
                  label="Ends"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                  initialValue={1}
                >
                  <Radio.Group
                    vertical
                    style={{
                      flexDirection: "column",
                      gap: "16px",
                    }}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        endRecurrenceType: e.target.value,
                      }))
                    }
                    value={formData.endRecurrenceType}
                    options={[
                      { value: 1, label: "Never" },
                      {
                        value: 2,
                        label: (
                          <>
                            On
                            <DatePicker
                              format={"YYYY-MM-DD"}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  recurrenceEndDate: e,
                                }));
                              }}
                              value={formData.recurrenceEndDate}
                              size="large"
                              style={{ marginInlineStart: 24 }}
                            />
                          </>
                        ),
                      },
                      {
                        value: 3,
                        label: (
                          <>
                            After
                            {/* {formData.endRecurrenceType === 3 && ( */}
                            <Input
                              //   variant="filled"
                              style={{ width: 160, marginInlineStart: 24 }}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  recurrenceMaxOccurrences: e.target.value,
                                }));
                              }}
                              value={formData.recurrenceMaxOccurrences}
                              type="number"
                              suffix={"occurences"}
                              size="large"
                            />
                            {/* )} */}
                          </>
                        ),
                      },
                    ]}
                  />
                </Form.Item>
              </>
            )}
          </Form>
        </Col>
      </Flex>

      <FormActions
        actionButtons={[
          {
            id: 1,
            buttonType: "primary",
            buttonHTMLType: "submit",
            buttonText: "Publish",
            handleButton: () => handlePublish(true),
          },
        ]}
      />
    </Flex>
  );
};

export default DeliverySchedule;
